import React, { Component } from 'react';
import { Col } from 'react-bootstrap';
//import { Link } from 'react-router-dom';

import './Footer.css';

class Footer extends Component {
  render() {
    return (
      <footer className='pfrFooter'>
        <div className="container">
          <Col sm={12} md={2} className="terms">
              <small>
            <a href='/terms/index.html'>TERMS OF USE</a>
        </small>
          </Col>
          <Col sm={12} md={10} className="copyright">
            <small>
              &copy; Copyright The New Zealand Institute for Bioeconomy Science Limited and the Ministry of Health (New Zealand) on behalf of the Crown, 2026. All rights reserved. 
              The use of any of the information on this page and any search results is governed by the Terms of Use. 
              By accessing and viewing this page or using any of the information including any search results you agree that you have read and accepted such Terms of Use.
            </small>
          </Col>
        </div>
      </footer>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/presentation/Footer/Footer.js